/**
 * Все подсказки интерфейса — в ОДНОМ месте.
 *
 * Причина: подсказка объясняет не кнопку, а промысловый смысл за ней, и текст
 * такого рода вычитывает владелец. Разбросанные по компонентам строки вычитать
 * нечем — их даже не собрать в один список. Здесь же видно сразу всё, что
 * кабинет обещает пользователю словами.
 *
 * С переходом на два языка сами ТЕКСТЫ уехали в каталог (`help.<id>.title` и
 * `help.<id>.text` в `i18n/ru.json`/`en.json`) — там их и вычитывают, теперь на
 * двух языках сразу. Здесь остался ПЕРЕЧЕНЬ: какие элементы кабинета вообще
 * имеют подсказку. Это по-прежнему один список, и он по-прежнему полон.
 *
 * Правила текстов (для каталога):
 *  • одно-три предложения, без вводных «данный элемент позволяет»;
 *  • говорим то, чего НЕ видно из подписи: границы, единицы, что считается
 *    в браузере, а что в базе, чего в данных нет вовсе;
 *  • не обещаем того, чего нет (устаревшие данные не подставляем, глубже
 *    6000 м изобат не бывает, а ниже 1000 м они идут через 500 м).
 */
import { t } from '../i18n'

export interface Hint {
  /** Заголовок облака — имя элемента, как он подписан в панели. */
  title: string
  text: string
}

/**
 * Элементы кабинета, у которых есть подсказка. Порядок — как в интерфейсе
 * сверху вниз: сначала общий контекст, потом наложения, потом инструменты.
 */
export const HINT_IDS = [
  'date',
  'species',
  'depth',
  'overlays',
  'fleet',
  'isotherm',
  'fronts',
  'isobaths',
  'waves',
  'layer',
  'model',
  'schools',
  'driftDepth',
  'hsiDrift',
  'export',
] as const

export type HintId = (typeof HINT_IDS)[number]

export function hintById(id: HintId): Hint {
  return { title: t(`help.${id}.title`), text: t(`help.${id}.text`) }
}
